// Parse and execute simple pipe-separated slash commands.
// Supported:
// - /send <text>      -> append to chat UI only
// - /trigger [<text>] -> send to server; if no <text>, send empty
// Example: 
//   (/send hi there|/trigger)
export function triggerSlash(input, deps) {
    const { appendToChatUI, sendToServer } = deps;
    if (!input || typeof input !== 'string')
        return { handled: false, commands: [] };
    // quick check: allow /send, /trigger, /setinput
    const hasCmd = /\/(send|trigger|setinput)\b/.test(input);
    if (!hasCmd)
        return { handled: false, commands: [] };
    // Strip optional wrappers like parentheses/backticks
    let s = String(input).trim();
    if ((s.startsWith('(') && s.endsWith(')')) || (s.startsWith('`') && s.endsWith('`'))) {
        s = s.slice(1, -1).trim();
    }
    // Split by pipe; keep empty arguments
    const parts = s.split('|').map((p) => p.trim()).filter((p) => p.length > 0);
    const executed = [];
    try {
        console.log('[triggerSlash] raw input:', input);
    }
    catch { }
    try {
        console.log('[triggerSlash] parts:', parts);
    }
    catch { }
    for (const part of parts) {
        const m = part.match(/^\/?(?<cmd>[a-zA-Z_][\w-]*)\b\s*(?<arg>[\s\S]*)$/);
        if (!m || !m.groups)
            continue;
        const name = (m.groups.cmd || '').toLowerCase();
        const arg = (m.groups.arg || '').trim();
        if (name === 'send') {
            try {
                console.log('[triggerSlash] /send arg=', arg);
            }
            catch { }
            if (arg.length)
                appendToChatUI(arg);
            executed.push({ name: 'send', arg });
            continue;
        }
        if (name === 'setinput') {
            try {
                console.log('[triggerSlash] /setinput arg=', arg);
            }
            catch { }
            deps.setInput?.(arg);
            executed.push({ name: 'setinput', arg });
            continue;
        }
        if (name === 'trigger') {
            try {
                console.log('[triggerSlash] /trigger arg=', arg);
            }
            catch { }
            // When no content, send empty text message
            sendToServer(arg || '');
            executed.push({ name: 'trigger', arg });
            continue;
        }
    }
    try {
        console.log('[triggerSlash] executed:', executed);
    }
    catch { }
    return { handled: executed.length > 0, commands: executed };
}
